import React, { ReactNode } from "react";

import "./SearchDocumentProductCatalog.less";

import { Product, ProductSource } from "@/Contracts/Products";
import { QuoteProduct } from "@/Contracts/ProposalBuilder/Block";
import { AllRolePermissions } from "@/Contracts/Users";
import SearchDocumentProductCatalogFuncComp from "./SearchDocumentProductCatalogFuncComp";
import SearchDocumentProductCatalogClassComp from "./SearchDocumentProductCatalogClassComp";
import UnifiedSearchDocumentProductCatalogDrawer from "../UnifiedSearchDocumentProductCatalogDrawer/UnifiedSearchDocumentProductCatalogDrawer";
import { useFeatureFlag } from "@/Hooks";

export interface Props {
	readonly onSubmit: (
		selectedProducts: Product[],
		productVsPricing: Record<string, string | null>,
		addingToBundle?: boolean
	) => void;
	readonly onClose?: ((e: any) => void) | undefined;
	readonly isLoading: boolean;
	readonly excludeBundles?: boolean;
	readonly itemType?: string;
	readonly isFromProductsPage: boolean;
	readonly configureDrawer?: ReactNode;
	readonly unfilledSelectedQuoteProductIds?: string[];
	readonly removeQuoteProducts?: (quoteProductIds: string[]) => void;
	readonly resetQuoteProducts?: () => void;
	readonly configureQuoteProduct?: (productId: string) => void;
	readonly onDellQuoteProductSubmit?: (product: QuoteProduct[]) => void;
	readonly source?: ProductSource | null;
	readonly createProductPermission?: AllRolePermissions[];
	readonly productVsPricing?: Record<string, string | null>;
	readonly hasPermissionForAmazonDistributor?: boolean;
	readonly openImportDrawer?: () => void;
}

const SearchDocumentProductCatalog: React.FC<Props> = props => {
	const search_document_product_catalog_func = useFeatureFlag(
		"search_document_product_catalog_func"
	);
	const isUnifiedSearchEnabled = useFeatureFlag("unified_product_search");

	if (isUnifiedSearchEnabled) {
		return <UnifiedSearchDocumentProductCatalogDrawer {...props} />;
	}

	return search_document_product_catalog_func ? (
		<SearchDocumentProductCatalogFuncComp
			{...props}
			isUnifiedSearchEnabled={isUnifiedSearchEnabled}
		/>
	) : (
		<SearchDocumentProductCatalogClassComp
			{...props}
			isUnifiedSearchEnabled={isUnifiedSearchEnabled}
		/>
	);
};

export default SearchDocumentProductCatalog;
